import React, { useEffect, useState } from "react";
import { useAuth } from "./items/AuthProvider";
import { QRCodeSVG } from "qrcode.react";

const QRpage = () => {
  const { user } = useAuth();
  const [qrData, setQRData] = useState("");

  useEffect(() => {
    if (user) {
      const qrCodeContent = JSON.stringify({
        _id: user._id,
      });
      setQRData(qrCodeContent);
    }
  }, [user]);

  return (
    <div className="container mx-auto p-4">
      <div className="text-center mt-40">
        {qrData && (
          <div className="flex flex-col items-center">
            <h1 className="text-3xl mb-10 font-bold">Login QR Code</h1>
            <QRCodeSVG
              value={qrData}
              size={256}
              level={"H"}
              className="mx-auto"
            />
            {/* <div className="mt-4">
              <p>
                <strong>Email:</strong> {user.email}
              </p>
              <p>
                <strong>Company:</strong> {user.company}
              </p>
            </div> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default QRpage;
